// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".alertForm span{margin-left:.5rem;font-weight:500}.alert_modal{height:auto}.alert_modal .modal-footer{display:none}.valid-btn{padding:0;font-size:10px;margin:0 1rem;height:25px !important;width:15%;line-height:inherit;text-transform:capitalize}\n", ""]);
// Exports
module.exports = exports;
